<script setup lang="ts">
import { computed, ref, watch } from "vue";
import { RuleDimension } from "@/modules/rule_engine/ruleEngineClasses";
import { useRuleEnginedStore } from "@/modules/rule_engine/store";

export type InSelection = {
	selectedValues: string[] | number[];
};

const props = defineProps<{
	type: "ab_test";
	selectedRuleDimension: RuleDimension;
}>();

const selection = defineModel<InSelection>();
const isInputValid = defineModel<boolean>("isInputValid", {
	default: () => ref(true),
});

const abTest = computed(() => {
	return useRuleEnginedStore().ruleEngineState.abTests.find(
		(abTest) => abTest.uuid === props.selectedRuleDimension.ab_test_uuid
	);
});

const selectedValues = computed({
	get() {
		return selection.value.selectedValues ?? [];
	},
	set(newValues) {
		selection.value = {
			selectedValues: newValues,
		};
	},
});

watch(
	selectedValues,
	() => {
		isInputValid.value = selectedValues.value.length > 0;
	},
	{ immediate: true }
);
</script>

<template>
	<v-select
		multiple
		chips
		closable-chips
		clearable
		variant="filled"
		density="compact"
		hide-details="auto"
		placeholder="Select variants"
		item-title="name"
		item-value="uuid"
		:items="abTest.variants ?? []"
		v-model="selectedValues"
	>
		<template v-slot:chip="{ props: chipProps, item }">
			<v-chip v-bind="chipProps" label size="small">
				{{ item.raw.name }}
			</v-chip>
		</template>
	</v-select>
</template>
